module.exports = __webpack_public_path__ + "img/icon_tracing.b2e11a73.svg";